// @flow

export const MIN_BREAKPOINT_WIDTH: number = 320; // px
export const MOBILE_BREAKPOINT_WIDTH: number = 375; // px
export const CLICK_THRESHOLD: number = 3; // px
export const CLICK_THRESHOLD_SQUARED: number = CLICK_THRESHOLD * CLICK_THRESHOLD;

export default {};
